module.exports = __webpack_public_path__ + "img/smartphone_black2.326a17b7.png";